module.exports = __webpack_public_path__ + "img/fancy_business_center.5cc1ff24.svg";